export default __webpack_public_path__ + "static/media/madame_detail12.8d249439.jpg";